export const CALCULATOR_GROUP_ROLES_V1 = Object.freeze([
    "prize",
    "rare",
    "highQuality",
    "general",
    "trash",
    "other",
]);

const CALCULATOR_GROUP_ROLE_RANKS_V1 = new Map(
    CALCULATOR_GROUP_ROLES_V1.map((role, rank) => [role, rank]),
);

export function isCalculatorGroupRoleV1(value) {
    return CALCULATOR_GROUP_ROLE_RANKS_V1.has(value);
}

export function calculatorGroupRoleRankV1(value) {
    return CALCULATOR_GROUP_ROLE_RANKS_V1.get(value);
}
